export default __webpack_public_path__ + "static/diahkharisma-f551496843736ddc7951a52ea7a42332.png";